import styles from './Footer.module.scss'

function Footer(){
    return (
        <div className={`${ styles.footer } d-flex flex-row align-items-center justify-content-center p-20`}>
            <p>Copyright &copy; 2022 Cookchef FullCycle, Corp.</p>
        </div>
    )
}

export default Footer